//3d carousel
function disableButtons(selector) {
    $(selector).addClass('noEvents')
    $(selector).attr("disabled", "disabled");
}


function enableButtons(selector) {
    $(selector).removeClass('noEvents')
    $(selector).removeAttr('disabled');
}

function threeDNavigationSetup() {
    $('.rightButton').on('click.threedcarousel', function () {
        threeDMove('right')
    })
    $('.leftButton').on('click.threedcarousel', function () {
        threeDMove('left')
    })

    //threeDButtons = rotating items/buttons
    threeDButtons = slides[globalVar.curSlide].items = $('.threedb')
    slides[globalVar.curSlide].clicks = 0;
    //Makes only the front button clickable
    disableButtons(threeDButtons)
    enableButtons(threeDButtons[0])

    //3d css setup
    cssSetup()
}

function cssSetup() {
    //html items to position
    var threeDItems = $('.threedb')

    //number of items
    var numberOfItems = threeDItems.length;

    //assign first positions
    threeDItems.each(function (idx, item) {
        $(item).addClass('item' + (idx + 1) + 'of' + numberOfItems + ' ' + numberOfItems + 'items')
    })
}


function threeDMove(rightOrLeft) {
    //threeDButtons = rotating items/buttons
    var threeDButtons = slides[globalVar.curSlide].items

    //clicks keeps track of the items's position
    var clicks = slides[globalVar.curSlide].clicks

    //number of items
    var numberOfItems = $('.threedb').length;

    //number for a left turn
    var turn;
    switch (rightOrLeft) {
        case "right":
            turn = numberOfItems - 1;
            break;
        case "left":
            turn = 1;
    }
    //change positions to the left
    threeDButtons.each(function (idx, button) {
        var currentPosition = ((idx + clicks) % numberOfItems) + 1;
        var nextPosition = ((idx + turn + clicks) % numberOfItems) + 1

        $(button).removeClass('item' + currentPosition + "of" + numberOfItems)
        $(button).addClass('item' + nextPosition + "of" + numberOfItems)

        //Makes only the new front button clickable
        if (nextPosition === 1) {
            disableButtons(threeDButtons)
            disableButtons(this)
            enableButtons(button)
        }
    })

    //prevent fast clicking
    // setTimeout(function () {
    //     enableButtons('.leftButton .rightButton')
    // }, 300)

    //update current position
    clicks += turn
    slides[globalVar.curSlide].clicks = clicks
}